//export const chatUrl = "http://localhost:8051/ai/deepseek/prompt_stream";
export const chatUrl = "https://ai.cnboss.cn/ai/deepseek/prompt_stream";
//export const chatUrl = "https://aitest.cnboss.cn/ai/deepseek/prompt_stream";
//export const chatUrl = "https://ai.cnboss.cn/ai/qianwen/prompt_stream";

//export const chatUrl = "http://localhost:8051/ai/qianwen/prompt_stream_v3";
//export const chatUrl = "https://ai.cnboss.cn/ai/qianwen/prompt_stream_v3";
//export const chatUrl = "https://aitest.cnboss.cn/ai/qianwen/prompt_stream_v3";